import React, { useReducer, useEffect } from 'react'
import { string } from 'prop-types'
import get from 'lodash/get'
import forEach from 'lodash/forEach'
import capitalize from 'lodash/capitalize'

import { defaultFetchState, createAsyncActionTypes } from 'libs/reducer'
import { getStat } from 'libs/services'
import { createStatDashboardConfig } from 'config/statDashboard'

import { StatList } from './Stats'

const actionTypes = createAsyncActionTypes('STATS')
const statsReducer = (state, action) => {
  const id = action.meta

  switch (action.type) {
    case actionTypes.request:
      return {
        ...state,
        [id]: {
          ...defaultFetchState,
          isRequest: true,
        }
      }
    case actionTypes.success:
      return {
        ...state,
        [id]: {
          ...defaultFetchState,
          isSuccess: true,
          ...action.payload,
        }
      }
    case actionTypes.failure:
      return {
        ...state,
        [id]: {
          ...defaultFetchState,
          isFailure: true,
          error: action.payload
        }
      }
    default:
      return state
  }
}

const StatsDashboard = ({ retrySubmitAction, retryWebhookAction }) => {
  const statDashboardConfig = createStatDashboardConfig(retrySubmitAction, retryWebhookAction)
  const [state, dispatch] = useReducer(statsReducer, {})
  const fetchAllStats = (forceUpdate = false) => {
    forEach({ ...statDashboardConfig.jobs, ...statDashboardConfig.all_status }, (_, id) => {
      if (get(state, `${id}.isSuccess`) && !forceUpdate) {
        return
      }

      dispatch({ type: actionTypes.request, meta: id })
      getStat(id, forceUpdate)
        .then(resp => dispatch({ type: actionTypes.success, payload: resp.data, meta: id }))
        .catch(err => dispatch({ type: actionTypes.failure, payload: err, meta: id }))
    })
  }

  useEffect(() => {
    fetchAllStats()
  }, [])

  const statCompAdapter = (stats = {}) => {
    const statItems = []

    forEach(stats, (config, id) => {
      const statById = get(state, id, {})
      statItems.push({
        ...statById,
        id,
        title: capitalize(get(statById, 'data.title', '')),
        total: get(statById, 'data.all', 0),
        last24Total: get(statById, 'data.last_24_hrs', 0),
        showLoading: get(statById, 'isRequest', false),
        ...config
      })
    })

    return statItems
  }

  return (
    <React.Fragment>
      <div className="pt-4 d-flex justify-content-between align-items-center">
        <h3 className="mb-0">All Status</h3>
        <div>
          <a
            style={{ cursor: 'pointer' }}
            className="ml-2"
            onClick={() => fetchAllStats(true)}
            role="button"
            tabIndex="0"
          >
            Clear Cache
          </a>
        </div>
      </div>
      <hr />
      <StatList items={statCompAdapter(statDashboardConfig.all_status)} />
      <h3 className="mt-3">Jobs</h3>
      <hr />
      <StatList items={statCompAdapter(statDashboardConfig.jobs)} />
    </React.Fragment>
  )
}

StatsDashboard.propTypes = {
  retrySubmitAction: string.isRequired,
  retryWebhookAction: string.isRequired,
}

export default StatsDashboard
